// extracted by mini-css-extract-plugin
export default {"menu_bar":"MainPage_menu_bar__oiqss","menu_bar_item":"MainPage_menu_bar_item__dPHRe"};